const initial = {
  class_id: null,
  status: 'hidden',
  callback: null
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('CLOSE_FORM');
    },
    create({commit}, {callback}) {
      commit('SHOW_FORM', {
        status: 'create',
        class_id: null,
        callback
      });
    },
    edit({commit}, {
      class_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'edit',
        class_id: class_id,
        callback
      });
    }
  },
  mutations: {
    CLOSE_FORM(state) {
      state.status = initial.status;
      state.class_id = initial.class_id;
      state.callback = initial.callback;
    },
    SHOW_FORM(state, {
      status,
      class_id,
      callback
    }) {
      state.status = status;
      state.class_id = class_id;
      state.callback = callback || initial.callback;
    }
  }
};
